export default __webpack_public_path__ + "86a76975d2b3c57c373e68f4df925570.webp";